import { Intent } from '@blueprintjs/core'

import { i18nKeys } from '../../app.i18n'

import {
  CountryCode,
  DevelopmentGoalDuration,
  DevelopmentGoalState,
  GoalPriority,
  GoalState,
  GoalType,
  OrganizationUnits,
} from './enums'

const GoalPriorityIntentMap: { [key: number]: Intent } = {
  [GoalPriority.Low]: Intent.NONE,
  [GoalPriority.Medium]: Intent.WARNING,
  [GoalPriority.High]: Intent.DANGER,
}

const GoalStateIntentMap: { [key: number]: Intent } = {
  [GoalState.Draft]: Intent.NONE,
  [GoalState.ToManager]: Intent.WARNING,
  [GoalState.Agreed]: Intent.SUCCESS,
  [GoalState.ReviewEmployee]: Intent.PRIMARY,
  [GoalState.ReviewManager]: Intent.PRIMARY,
  [GoalState.ReviewEmployeeManager]: Intent.PRIMARY,
  [GoalState.OpenForCalibration]: Intent.PRIMARY,
  [GoalState.Calibrated]: Intent.SUCCESS,
  [GoalState.Finished]: Intent.SUCCESS,
}

const DevelopmentGoalStateIntentMap: { [key: number]: Intent } = {
  [DevelopmentGoalState.Draft]: Intent.NONE,
  [DevelopmentGoalState.ToManager]: Intent.WARNING,
  [DevelopmentGoalState.Agreed]: Intent.SUCCESS,
  [DevelopmentGoalState.ReviewEmployee]: Intent.PRIMARY,
  [DevelopmentGoalState.ReviewManager]: Intent.PRIMARY,
  [DevelopmentGoalState.Completed]: Intent.SUCCESS,
  [DevelopmentGoalState.NotCompleted]: Intent.DANGER,
}

const GoalTypeI18 = i18nKeys.frontFace.goals.types.base
const GoalStateI18 = i18nKeys.frontFace.goals.states.base
const GoalStateI18Enmployee = i18nKeys.frontFace.goals.statesEmployee.base
const DevelopmentGoalStateI18 = i18nKeys.frontFace.developmentGoals.states.base
const GoalPriorityI18 = i18nKeys.frontFace.goals.priorities.base
const DevGoalDurationI18 = i18nKeys.frontFace.devGoals.duration.base

export const GoalStateMap: string[] = Object.keys(GoalState)
  .filter((key) => !isNaN(Number(key)))
  .map((key) => GoalState[Number(key)])
  .filter((value) => typeof value === 'string')

export const GoalStateMap2 = [
  { name: GoalState[GoalState.Draft], id: GoalState.Draft },
  { name: GoalState[GoalState.ToManager], id: GoalState.ToManager },
  { name: GoalState[GoalState.Agreed], id: GoalState.Agreed },
  { name: GoalState[GoalState.ReviewEmployee], id: GoalState.ReviewEmployee },
  { name: GoalState[GoalState.ReviewManager], id: GoalState.ReviewManager },
  { name: GoalState[GoalState.Finished], id: GoalState.Finished },
  { name: GoalState[GoalState.OpenForCalibration], id: GoalState.OpenForCalibration },
  { name: GoalState[GoalState.Calibrated], id: GoalState.Calibrated },
  { name: GoalState[GoalState.Canceled], id: GoalState.Canceled },
]

export const GoalStateMap2EmployeeOnly = [
  { name: GoalState[GoalState.Draft], id: GoalState.Draft },
  { name: GoalState[GoalState.ToManager], id: GoalState.ToManager },
]

export const TeamGoalStateMap = [
  { name: GoalState[GoalState.Draft], id: GoalState.Draft },
  { name: GoalState[GoalState.Agreed], id: GoalState.Agreed },
  { name: GoalState[GoalState.ReviewManager], id: GoalState.ReviewManager },
  { name: GoalState[GoalState.Finished], id: GoalState.Finished },
  { name: GoalState[GoalState.OpenForCalibration], id: GoalState.OpenForCalibration },
  { name: GoalState[GoalState.Calibrated], id: GoalState.Calibrated },
]

export const DevelopmentGoalStateMap = [
  { name: DevelopmentGoalState[DevelopmentGoalState.Draft], id: DevelopmentGoalState.Draft },
  { name: DevelopmentGoalState[DevelopmentGoalState.Agreed], id: DevelopmentGoalState.Agreed },
  { name: DevelopmentGoalState[DevelopmentGoalState.ToManager], id: DevelopmentGoalState.ToManager },
  { name: DevelopmentGoalState[DevelopmentGoalState.ReviewEmployee], id: DevelopmentGoalState.ReviewEmployee },
  { name: DevelopmentGoalState[DevelopmentGoalState.ReviewManager], id: DevelopmentGoalState.ReviewManager },
  { name: DevelopmentGoalState[DevelopmentGoalState.Completed], id: DevelopmentGoalState.Completed },
  { name: DevelopmentGoalState[DevelopmentGoalState.NotCompleted], id: DevelopmentGoalState.NotCompleted },
]

const DevelopmentGoalCountrycode: { [key: number]: CountryCode } = {
  [OrganizationUnits.CZSK]: CountryCode.cz,
  [OrganizationUnits.KZ]: CountryCode.kz,
  [OrganizationUnits.CN]: CountryCode.cn,
  [OrganizationUnits.RU]: CountryCode.ru,
  [OrganizationUnits.INDS]: CountryCode.inds,
  [OrganizationUnits.IN]: CountryCode.in,
  [OrganizationUnits.VN]: CountryCode.vn,
  [OrganizationUnits.US]: CountryCode.us,
  [OrganizationUnits.PHI]: CountryCode.phi,
}

export function developmentGoalOrgUnitOwnerOwnerTocountryCode(state: number): string {
  return `${DevelopmentGoalCountrycode[state]}`
}

const createSelectOptionFn = (text: string, value: number | string) => {
  return { value, text }
}

// "hacky" use of createSelectOptionFn -> map accepts (value: string, index: number, array: string[]) function
// so index is in this case "value" param of createSelectOptionFn\

// const GoalStateSelectOptions = GoalStateMap.map(createSelectOptionFn)
const GoalStateSelectOptions2 = GoalStateMap2.map((goalState) => createSelectOptionFn(goalState.name, goalState.id))
const GoalStateSelectOptions2EmployeeOnly = GoalStateMap2EmployeeOnly.map((goalState) =>
  createSelectOptionFn(goalState.name, goalState.id)
)

const TeamGoalStateSelectOptions = TeamGoalStateMap.map((goalState) =>
  createSelectOptionFn(goalState.name, goalState.id)
)
export const DevelopmentGoalStateSelectOptions = DevelopmentGoalStateMap.map((goalState) =>
  createSelectOptionFn(goalState.name, goalState.id)
)

export function getGoalStateMap(isTeam: boolean, isAdmin: boolean) {
  return isTeam ? TeamGoalStateSelectOptions : isAdmin ? GoalStateSelectOptions2 : GoalStateSelectOptions2EmployeeOnly
}

export function getDevelopmentGoalStateMap() {
  return DevelopmentGoalStateSelectOptions
}

export function goalPriorityToString(priority: GoalPriority | number) {
  return `${GoalPriorityI18}.${Number(priority)}`
}

export function goalPriorityToIntent(priority: GoalPriority | number) {
  return GoalPriorityIntentMap[priority]
}

export function goalStateToString(state: GoalState | number) {
  return `${GoalStateI18}.${Number(state)}`
}

export function goalStateToStringWithoutEditRights(state: GoalState | number) {
  return `${GoalStateI18Enmployee}.${Number(state)}`
}

export function developmentGoalStateToString(state: DevelopmentGoalState | number) {
  return `${DevelopmentGoalStateI18}.${Number(state)}`
}

export function goalTypeToString(state: GoalType | number) {
  return `${GoalTypeI18}.${Number(state)}`
}

export function goalStateToIntent(state: GoalState | number) {
  return GoalStateIntentMap[state]
}

export function developmentGoalStateToIntent(state: GoalState | number) {
  return DevelopmentGoalStateIntentMap[state]
}

export function devGoalDurationToString(duration: DevelopmentGoalDuration | number) {
  return `${DevGoalDurationI18}.${Number(duration)}`
}



// WEBPACK FOOTER //
// ./src/app/front-face/models/mappers.ts